import { useContext, useMemo } from 'react';
import { AuthContext } from '../Contexts/AuthContext';
import { isValidDate, localOf } from '../utils/localDate';

export const ORG_CREATED_AT_FALLBACK = localOf(2022, 0, 1);

/** Reads the context directly, not via useAuth, so the picker renders outside a provider. */
export const useOrgCreatedAt = (): Date => {
  const createdAt = useContext(AuthContext)?.status?.organization?.created_at;

  return useMemo(() => {
    if (!createdAt) return ORG_CREATED_AT_FALLBACK;

    const parsed = new Date(createdAt);
    return isValidDate(parsed) ? parsed : ORG_CREATED_AT_FALLBACK;
  }, [createdAt]);
};

export default useOrgCreatedAt;
